
<template>
<div class="container-fluid m-0 p-0">

  <div id="home-page" class="full-height  p-4" >

    <div class="container pt-3" >
<!-- Linke Seite -->
      <div class="row pb-5">
        <div class="col-lg-6 pt-4 my-auto">
          <!-- Grosser Bildschirm Titel rechte Seite d-block d-lg-none -->
          <div class="mydiv text-center mb-3 d-block d-lg-none">


          </div>
          <!-- <img id="bottle-img" src="../assets/wordcloud.svg" class="img-fluid"> -->

        </div>
<!-- rechte Seite -->
        <div class="col-lg-6 my-auto pt-4">
          <!-- Grosser Bildschirm Titel oberhalb d-none d-lg-block -->

          <div class="text-center mb-3 d-none d-lg-block">
          <!-- <h1 class="display-3">{{ title }}</h1> -->
          <!-- <h3>GIB</h3> -->
          </div>




          <div id="contact" class="p-7">

          <h2>coming soon..</h2>

          <div class="container">
            <iframe id="yt-vid" class="responsive-iframe"
            src="https://www.youtube.com/embed/f2jG6J1JdtU" >
            </iframe>

          </div>

          <div class="">
            <h2>stay tuned!</h2>

          </div>





        </div>


        </div>
      </div>

    </div>
  </div>



  <!-- Quotes -->
  <div id="about" class="p-3 p-md-5">
      <button @click="generate" class="btn btn-lg active" id="btn">GIB Statement!</button>
      <p class="statement">{{ quote.quote }}</p>
      <p class="person">{{ quote.cite }}</p>
    </div>


</div>


</template>

<script>

const quotes = [
  {
    quote:
      "GIB ihm, GIB ihr, GIB mir, Gib dir!",
    cite: "GIBoholic",
  },
  {
    quote:
      "GIB isch geil!",
    cite: "addicted person",
  },
  {
    quote: "Ich weiss no, woni ichs s erst mal im Muul ka han, han ich gwüsst ich bruch meh!",
    cite: "loves the taste",
  },
  {
    quote: "Sbeste wos je hets GIB!",
    cite: "biggest fan",
  },
  {
    quote:
      "GIB gföhrlich, intensiv belicious",
    cite: "G I B",
  },
  {
    quote:
      "GIB GIB HURRAY!",
    cite: "heureka",
  },
  {
    quote:
      "Wenn ich mir Gib den GIB!",
    cite: "wants more",
  },
  {
    quote:
      "GIB dier d Kante!",
    cite: "can´t stop",
  },

];

export default {
  name: "App",
  data() {
    return { quote: {} };
  },
  methods: {
    generate() {
      const index = Math.floor(Math.random() * quotes.length);
      this.quote = quotes[index];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



#home-page {
  background-color: #92D2F2;
  background: url("../assets/gib_landingpage.jpg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.mydiv{
  position: relative;
}

#bottle-img {
  max-height: 100vh;


}

#about{
  min-height: 20vh;
  background-color: #d9d9d9;
}

#contact{
  margin-left: auto;
  margin-right: auto;

}

#footer{
  background-color: rgba(0, 0, 0, 0.99);
}

#email-font{
  color: white;
  font-family: cheap-pine-sans, sans-serif;
  font-weight: 400;
  font-style: normal;
}

#event{

  font-size: 4rem;

}

#felder{
  font-family: roboto;

}

#sendButton{
padding: 1rem 7rem;

}

#btn {
  background-color: rgb(235, 175, 60)
}



h2{
  color: white;
  font-family: cheap-pine-sans, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 7rem;
  padding-top: 3rem;
  padding-bottom: 5rem;



}

.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.statement{
  padding-top: 1rem;
  font-size: 2rem;
  font-family: cheap-pine-sans, sans-serif;
}

.person{
  

}







</style>
